import { Box, Grid } from "@mui/material";
import CognitoForgotPasswordForm from "./cognito/CognitoForgotPasswordForm";
import { AuthHeader } from "./components/Headers";

export default function ForgotPassword({
  formState,
  updateFormState,
  updateFormType,
  setProcessing,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <AuthHeader text="Forgot Password" />

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12}>
          <CognitoForgotPasswordForm
            formState={formState}
            updateFormState={updateFormState}
            updateFormType={updateFormType}
            setProcessing={setProcessing}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
